module.exports = __webpack_public_path__ + "img/planning.3fc1eff2.png";